import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import AccountLinks from '../../containers/AccountLinks';
import LogInButtons from '../LogInButtons/LogInButtons';
import MenuTitle from '../MenuTitle/MenuTitle';

import styles from './VerticalAccountMenu.scss';

function VerticalAccountMenu(props) {
    const {
        isLoggedIn,
        userFirstName,
        onLogOut,
        onMenuToggle,
    } = props;

    function _onLogOut(e) {
        onMenuToggle();
        onLogOut();
    }

    return (
        <div className={styles.container}>
            <nav className={styles.menu}>
                {!isLoggedIn && <LogInButtons navType="hamburger" onClick={onMenuToggle} />}
                <div
                    className={classNames(
                        styles.linksContainer,
                        { [styles.isLoggedIn]: isLoggedIn },
                    )}
                >
                    {isLoggedIn && (
                        <MenuTitle
                            greetingClassName={styles.greeting}
                            userFirstName={userFirstName}
                            isLoggedIn
                        />
                    )}
                    <AccountLinks
                        isLoggedIn={isLoggedIn}
                        linkClassName={styles.link}
                        navType="hamburger"
                        onClick={onMenuToggle}
                        onLogOut={_onLogOut}
                    />
                </div>
            </nav>
        </div>
    );
}

VerticalAccountMenu.propTypes = {
    isLoggedIn: PropTypes.bool,
    userFirstName: PropTypes.string,
    onMenuToggle: PropTypes.func,
    onLogOut: PropTypes.func,
};

VerticalAccountMenu.defaultProps = {
    isLoggedIn: false,
    userFirstName: '',
    onMenuToggle() {},
    onLogOut() {},
};

export default VerticalAccountMenu;
